import React from 'react';
import Typography from '@mui/material/Typography';

const Dashboard = () => {
	return (
		<div>
			<Typography paragraph></Typography>
			<Typography paragraph></Typography>
		</div>
	);
};

export default Dashboard;
